<template>
    <PharmacistsRequests
        :appointment="appointment"
        :pharmacy="pharmacy"
        :assignedPharmacist="assignedPharmacist"
        :knownPharmacists="knownPharmacists"
        :numOfRequests="numOfRequests"
        :selection-enabled="false"
        :hydrate-on-dialog-open="true"
    />
</template>

<script>
import PharmacistsRequests from '../pharmacist/requests/PharmacistsRequests.vue';

export default {
    components: {
        PharmacistsRequests,
    },
    props: {
        appointment: Object,
        pharmacy: Object,
        assignedPharmacist: Object,
        knownPharmacists: Array,
        numOfRequests: Number,
    },
}
</script>
